/** The product tag for this app, shared across identity and analytics.
 *
 *  Sent to the identity service as `product` (selects email branding /
 *  SparkPost templates — the service 422s unknown values) and used as the
 *  Amplitude `app` property that distinguishes Tokenwise from the other
 *  Studio sub-apps sharing the studio.ai21.com host. Must be exactly
 *  "tokenwise". Distinct from VITE_APP_NAME
 *  ("ai21-intelligent-gateway-webapp", the OTel service name). */
export const PRODUCT = "tokenwise" as const;
